import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", { class: "mb-8 text-3xl font-semibold" }, "Sign up", -1)
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { class: "block text-xs" }, "Name", -1)
const _hoisted_4 = { class: "mb-8" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { class: "block text-xs" }, "Email", -1)
const _hoisted_6 = { class: "mb-8" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { class: "block text-xs" }, "Password", -1)
const _hoisted_8 = { class: "mb-8" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "block text-xs" }, "Repeat Password", -1)
const _hoisted_10 = {
  key: 0,
  class: "mb-8 text-sm text-red-400",
  "data-testid": "error-message"
}
const _hoisted_11 = { class: "flex items-center text-sm" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Log in ")
const _hoisted_13 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_icon_component = _resolveComponent("icon-component")
  const _component_button_component = _resolveComponent("button-component")

  return (_openBlock(), _createBlock("form", {
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
    class: "p-4 rounded w-96 bg-primary-dark"
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        class: "w-full p-2 py-1 border rounded-sm focus:outline-none",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
        type: "text",
        "data-testid": "name-input"
      }, null, 512), [
        [_vModelText, _ctx.name]
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createVNode("input", {
        class: "w-full p-2 py-1 border rounded-smfocus:outline-none",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.email = $event)),
        type: "text",
        "data-testid": "email-input"
      }, null, 512), [
        [_vModelText, _ctx.email]
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _withDirectives(_createVNode("input", {
        class: "w-full p-2 py-1 border rounded-sm focus:outline-none",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.password = $event)),
        type: "password",
        "data-testid": "password-input"
      }, null, 512), [
        [_vModelText, _ctx.password]
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _hoisted_9,
      _withDirectives(_createVNode("input", {
        class: "w-full p-2 py-1 border rounded-sm focus:outline-none",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.passwordConfirm = $event)),
        type: "password",
        "data-testid": "password-confirm-input"
      }, null, 512), [
        [_vModelText, _ctx.passwordConfirm]
      ])
    ]),
    (_ctx.error && _ctx.error !== '')
      ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_router_link, {
        class: "flex items-center mr-8",
        to: "/login"
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      }),
      _createVNode(_component_button_component, {
        disalbed: _ctx.isLoading,
        onClick: _ctx.signUp,
        class: "ml-auto",
        "data-testid": "submit-button"
      }, {
        default: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode(_component_icon_component, {
                  icon: _ctx.Icon.LOADING,
                  class: "h-5 animate-spin"
                }, null, 8, ["icon"])
              ]))
            : (_openBlock(), _createBlock("span", _hoisted_14, "Submit"))
        ]),
        _: 1
      }, 8, ["disalbed", "onClick"])
    ])
  ], 32))
}